import {
  observable,
  action,
} from 'mobx';
import {
  type LockableButtonGroupState,
  getInitialState,
} from '../components/DeviceAsDom/components/LockableButtonGroup/LockableButtonGroup';

class LockableButtonStore {
  @observable
    buttonStates: Record<string, LockableButtonGroupState> = {};

  @action
  setButtonState(id: string, state: LockableButtonGroupState) {
    this.buttonStates[id] = state;
  }

  getButtonState(id: string) {
    return this.buttonStates[id] || getInitialState();
  }
}

export default LockableButtonStore;
